define('entities/admin/email_addresses',[
  'app',
  'jquery',
  'underscore',
  'backbone',
  'settings',
  'backboneRelational'
], function (
  App,
  $,
  _,
  Backbone,
  Settings
) {
  'use strict';

  var app;
  if (Backbone.Relational.store._modelScopes && Backbone.Relational.store._modelScopes.length > 0) {
    app = { ns: Backbone.Relational.store._modelScopes[0] };
  } else {
    app = { ns: {} };
    Backbone.Relational.store.addModelScope(app.ns);
  }

  app.ns.EmailAddressAdmin = Backbone.RelationalModel.extend({
    defaults: {
      secId: null,
      email: '',
      nameFrom: '',
      members: [],
      memberCount: 0
    },
    idAttribute: 'secId'
  });

  App.reqres.setHandler('emailAddresses:model', function (json) {
    var existing = null;
    if (json && json.secId) {
      existing = Backbone.Relational.store.find(app.ns.EmailAddressAdmin, json.secId);
    }
    if (existing) {
      existing.set(json);
      return existing;
    }
    return new app.ns.EmailAddressAdmin(json);
  });

  var API = {
    getListUrl: function (params) {
      return Settings.url('compuzz2', 'v2/emailaddressadmin', params);
    },
    getRowCountUrl: function () {
      return Settings.url('compuzz2', 'v2/emailaddressadmin/rowCount');
    },
    getOneUrl: function (secId) {
      return Settings.url('compuzz2', 'v2/emailaddressadmin/' + secId);
    },
    getCanEditUrl: function () {
      return Settings.url('compuzz2', 'v2/emailaddressadmin/canEdit');
    },
    getAddMemberUrl: function (secId) {
      return Settings.url('compuzz2', 'v2/emailaddressadmin/' + secId + '/members');
    },
    getRemoveMemberUrl: function (secId, userpidSecId) {
      return Settings.url('compuzz2', 'v2/emailaddressadmin/' + secId + '/members/' + userpidSecId);
    },
    getUserpidSearchUrl: function (params) {
      return Settings.url('compuzz2', 'v2/userpid', params);
    }
  };

  App.reqres.setHandler('emailAddresses:get-url', function (params) {
    return API.getListUrl(params);
  });

  App.reqres.setHandler('emailAddresses:row-count-url', function () {
    return API.getRowCountUrl();
  });

  App.reqres.setHandler('emailAddresses:canEdit', function () {
    var defer = $.Deferred();
    $.ajax({
      type: 'GET',
      url: API.getCanEditUrl(),
      success: function (data) {
        defer.resolve(data && data.canEdit === true);
      },
      error: function (xhr) {
        if (window.console && console.warn) {
          console.warn('emailAddresses:canEdit failed', xhr && xhr.status);
        }
        defer.resolve(false);
      }
    });
    return defer.promise();
  });

  App.reqres.setHandler('emailAddresses:get', function (secId) {
    var defer = $.Deferred();
    $.ajax({
      type: 'GET',
      url: API.getOneUrl(secId),
      success: function (data) { defer.resolve(data); },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  });

  App.reqres.setHandler('emailAddresses:add-member', function (secId, userpidSecId) {
    var defer = $.Deferred();
    $.ajax({
      type: 'POST',
      url: API.getAddMemberUrl(secId),
      contentType: 'application/json',
      data: JSON.stringify({ userpidSecId: userpidSecId }),
      success: function () { defer.resolve(); },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  });

  App.reqres.setHandler('emailAddresses:remove-member', function (secId, userpidSecId) {
    var defer = $.Deferred();
    $.ajax({
      type: 'DELETE',
      url: API.getRemoveMemberUrl(secId, userpidSecId),
      success: function () { defer.resolve(); },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  });

  App.reqres.setHandler('emailAddresses:search-userpids', function (query) {
    var defer = $.Deferred();
    var params = { pageSize: 20, first: 0 };
    if (query && query.length > 0) {
      params.firstName = query;
    }
    $.ajax({
      type: 'GET',
      url: API.getUserpidSearchUrl(params),
      success: function (data) { defer.resolve(data || []); },
      error: function () { defer.resolve([]); }
    });
    return defer.promise();
  });
});

